var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:'sub-banner d-flex align-items-center justify-content-center ' + [_vm.alt_banner]},[_c('div',{staticClass:"container page-title text-center"},[_c('h1',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }